/* eslint-disable import/no-extraneous-dependencies */
import React, { Component } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import { stringify } from 'qs';
import { Table, Divider, Modal } from 'antd';
import Header from '../../components/Header/index';
import UploadModal from '../../../companents/UploadModal';
import {
  downTeacherUrl,
  uploadTeacher,
  downUserExport,
  exportUserUrl,
} from '../../../services/personnel/personnel';
import styles from './index.less';

const { confirm } = Modal;

@connect(({ countyPersonnel }) => {
  return {
    ...countyPersonnel,
  };
})
class Teacher extends Component {
  constructor(props) {
    super(props);

    this.headerRef = React.createRef();
    this.actionBtn = {
      title: '操作',
      dataIndex: '',
      fixed: 'right',
      visible: true,
      render: record => (
        <span className="table-action-box">
          <a
            className="table-action-edit"
            onClick={event => this.handleGoToEdit({ record, event })}
          >
            编辑
          </a>
          <Divider type="vertical" />
          <a className="table-action-delete" onClick={event => this.handleDelete(record, event)}>
            删除
          </a>
        </span>
      ),
    };

    this.state = {
      uploadModalVisible: false, // 导入modal的显示状态
    };

    this.handleSelectedChange = this.handleSelectedChange.bind(this);
    this.handleGetList = this.handleGetList.bind(this);
    this.renderTableTitle = this.renderTableTitle.bind(this);
    this.handleDeleteBatchs = this.handleDeleteBatchs.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleUploadCancel = this.handleUploadCancel.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  componentDidMount() {
    this.handleGetList();
  }

  // 跳转编辑页面
  handleGoToEdit = ({ record, event }) => {
    if (event) {
      event.stopPropagation();
    }
    const { userId } = record;

    router.push(
      `/countyContacts/personnel/edit?${stringify({ userId, userType: 'teacher' })}`
    );
  };

  // 修改页面
  handleChangePagination = page => {
    this.handleGetList({ page });
  };

  handleFieldConfirm = attrList => {
    const { dispatch } = this.props;
    dispatch({
      type: 'countyPersonnel/save',
      payload: {
        columns: attrList,
      },
    });
  };

  // 导入modal状态改变
  handleUploadCancel(status = false) {
    this.setState({
      uploadModalVisible: status,
    });
  }

  // 导入
  handleUpload({ fileList }) {
    const { dispatch } = this.props;
    const { response = {} } = fileList.pop();
    const { data = {} } = response;

    dispatch({
      type: 'countyPersonnel/fetchUploadTeacher',
      params: { ...data },
      callback: taskId => {
        this.handleUploadCancel();
        router.push(
          `/countyContacts/import?${stringify({
            taskId,
            type: 'teacher',
          })}`
        );
      },
    });
  }

  handleShowSizeChange(pageSize) {
    this.handleGetList({ pageSize });
  }

  // 获取学生列表数据
  handleGetList({ searchParam = {}, page = 1, pageSize } = {}) {
    const { dispatch, pageInfo } = this.props;
    let searchParams = searchParam;
    const { pageSize: oldPageSize } = pageInfo;
    let newPageSize = pageSize;

    if (!newPageSize) {
      newPageSize = oldPageSize;
    }

    if (this.headerRef && !searchParam.searchField) {
      const { state } = this.headerRef.current;
      const { searchInfo, searchValue } = state;
      const { type, deptSign } = searchInfo;

      searchParams = {
        deptType: type,
        deptId: deptSign,
        searchField: searchValue,
      };
    }

    dispatch({
      type: 'countyPersonnel/fetchList',
      searchParams: { ...searchParams, userType: 'teacher', curPage: page, pageSize: newPageSize },
      actionBtn: this.actionBtn,
    });
  }

  // table选中
  handleSelectedChange(selectedRowKeys) {
    const { dispatch } = this.props;

    dispatch({
      type: 'countyPersonnel/save',
      payload: { selectedRowKeys },
    });
  }

  // 单条删除
  handleDelete({ userId = '' }, event) {
    if (event) {
      event.stopPropagation();
    }

    confirm({
      title: `确定要删除吗？`,
      content: '删除有风险，请仔细确认后执行删除操作',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        this.handleDeleteBatchs([userId], 1);
      },
    });
  }

  // 批量删除
  handleDeleteBatchs(selectedRowKeys, deleteType = 2) {
    const { dispatch } = this.props;

    dispatch({
      type: 'countyPersonnel/fetchDelBatchs',
      payload: { userIds: selectedRowKeys, userType: 'teacher' },
      deleteType,
      callback: this.handleGetList,
    });
  }

  // 搜索
  handleSearch(searchParams) {
    const { dispatch } = this.props;

    dispatch({
      type: 'countyPersonnel/fetchSearch',
      searchParams: { ...searchParams, userType: 'teacher' },
    });
  }

  // 渲染选中信息
  renderTableTitle() {
    const { selectedRowKeys } = this.props;

    return (
      <>
        {!!selectedRowKeys.length && (
          <div className="table-selected-info">
            已选 <span>{selectedRowKeys.length}</span> 人
          </div>
        )}
      </>
    );
  }

  render() {
    const {
      list = [],
      columns,
      selectedRowKeys,
      deptTypeList,
      deptTreeList,
      handleSetSelectedDeptVisible,
      tableId,
      handleUserClick,
      pageInfo,
    } = this.props;
    const { uploadModalVisible } = this.state;
    const { totalElements, pageSize, curPage } = pageInfo;

    const rowSelection = {
      onChange: this.handleSelectedChange,
    };

    const columnList = columns.filter(({ visible }) => !!visible);

    const tableProps = {
      selectedRowKeys,
      rowSelection,
      columns: columnList,
      dataSource: list,
      rowKey: 'userId',
      title: this.renderTableTitle,
      scroll: { x: 'max-content' },
      pagination: {
        pageSize,
        total: totalElements,
        pageSizeOptions: ['20', '50', '100', '200'],
        current: curPage,
        defaultPageSize: 20,
        showSizeChanger: true,
        showQuickJumper: true,
        onChange: this.handleChangePagination,
        onShowSizeChange: (current, size) => this.handleShowSizeChange(size),
      },
      onRow: record => ({
        onClick: () => {
          if (handleUserClick) handleUserClick(record.userId);
        },
      }),
    };

    if (totalElements > 0) {
      tableProps.footer = () => (
        <div className="table-footer">{`共 ${totalElements} 条记录 第 ${curPage} 页`}</div>
      );
    }

    const headerProps = {
      handleDeleteBatchs: this.handleDeleteBatchs,
      selectedRowKeys,
      deptTypeList,
      deptTreeList,
      handleFetchList: this.handleGetList,
      handleSearch: this.handleSearch,
      handleUpload: this.handleUploadCancel,
      downUserExport,
      exportUserUrl,
      columnList,
      columns,
      onFieldConfirm: this.handleFieldConfirm,
      handleSetSelectedDeptVisible,
      userType: 'teacher',
    };

    return (
      <div className={styles.teacher}>
        <Header {...headerProps} ref={this.headerRef} />

        <Table {...tableProps} key={tableId} />

        {!!uploadModalVisible && (
          <UploadModal
            onCancel={this.handleUploadCancel}
            onOk={this.handleUpload}
            downUrl={downTeacherUrl}
            actionUrl={uploadTeacher}
            title="批量导入人员"
          />
        )}
      </div>
    );
  }
}

export default Teacher;
